import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { BsPlusCircle } from 'react-icons/bs';
import { styled } from '@mui/material/styles';
import ApiServices from 'services';
import Utils from 'commons/utils';
import { Table, ShowListFile, ModalFormDetail } from 'components';
import { ContainerHeader, BtnCreateContract } from '../styles';
import { RecordCreateForm } from './record-create-form';

const RecordForm = ({ selectedContract, getContractDetail, isReadOnly = false }) => {
  const [loading, setLoading] = useState(false);
  const [showCreateRecord, setShowCreateRecord] = useState(null);

  const handleShow = () => {
    setShowCreateRecord({ isNew: true });
  };
  const handleClose = () => {
    setShowCreateRecord(null);
  };

  const handleSubmit = async (dataSend) => {
    const contractId = selectedContract?.id;
    if (!contractId || !dataSend) return;

    try {
      const res = await ApiServices.createContractRecord(contractId, dataSend);
      if (res?.status === 200) {
        window.UIMessage?.success('Thêm mới thành công');
        handleClose();
        getContractDetail(contractId);
      }
    } catch (error) {
      window.UIMessage?.error('Thêm mới thất bại !!!');
      console.log('Create Contract Failed:::', error);
    }
  };

  const handleDelete = async (rowData) => {
    const contractId = selectedContract?.id;
    const recordCode = rowData?.code;
    if (!contractId || !recordCode) return;
    try {
      const res = await ApiServices.getRemoveContractRecord(contractId, recordCode);
      if (res?.status === 200) {
        window.UIMessage?.success('Xóa thành công');
        getContractDetail(contractId);
      }
    } catch (error) {
      window.UIMessage?.error('Xóa thất bại !!!');
      console.log('Delete Contract Failed:::', error);
    }
  };

  const columns = [
    {
      id: 'code',
      numeric: true,
      disablePadding: false,
      label: 'Mã hồ sơ',
      align: 'center',
      width: '150px',
    },
    {
      id: 'name',
      numeric: true,
      disablePadding: false,
      label: 'Tên hồ sơ',
      align: 'center',
      width: '300px',
    },
    {
      id: 'urlFile',
      numeric: true,
      disablePadding: false,
      label: 'File hồ sơ',
      align: 'center',
      render: (row) => <ShowListFile maxWidth="200px" fileList={row?.urlFile} />,
    },
    {
      id: 'expireDate',
      numeric: true,
      disablePadding: false,
      label: 'Ngày hết hạn',
      align: 'center',
      width: '150px',
      render: (row) => Utils.formatDateFn(row?.expireDate),
    },
    {
      id: 'note',
      numeric: true,
      disablePadding: false,
      label: 'Ghi chú',
      align: 'center',
      width: '200px',
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: false,
      label: 'Thao tác',
      width: '10px',
      fixed: 'right',
      align: 'center',
      render: (row) => (
        <Button
          disabled={isReadOnly}
          variant="contained"
          size="small"
          color="error"
          sx={{ borderRadius: '15px', textTransform: 'none' }}
          onClick={() => handleDelete(row)}
        >
          Xoá
        </Button>
      ),
    },
  ];

  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Danh sách hồ sơ
        </Typography>
      </ContainerHeader>
      <BtnCreateContract
        disabled={isReadOnly}
        variant="contained"
        startIcon={<BsPlusCircle />}
        onClick={handleShow}
      >
        Thêm mới
      </BtnCreateContract>
    </>
  );

  return (
    <Box>
      <Table
        rows={selectedContract?.arrFileDocument || []}
        headCells={columns}
        // totalRecords={totalRecords}
        onPageChange={(paging) => {}}
        // onClickDetail={handleSelected}
        loading={loading}
        renderHeader={renderHeader}
      />
      <ModalFormDetail
        open={showCreateRecord}
        onCloseModal={handleClose}
        title="Thêm mới phụ lục"
        maxWidth="sm"
      >
        <RecordCreateForm onSubmit={handleSubmit} isReadOnly={isReadOnly} />
      </ModalFormDetail>
    </Box>
  );
};

export { RecordForm };

export const ButtonAdd = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '5px',
  marginLeft: 'auto',
  color: '#FFF',
  border: '1px solid rgba(0, 0, 0, 0.4)',
  padding: '4px 15px',
  '.MuiButton-startIcon': {
    marginRight: '2px',
  },
}));
